import Api from '../api';

const UserAPI = {
  verify(data) {
    return Api.post('/users/verify', { data });
  },
  resetPassword(token, data) {
    return Api.put(`/users/${token}/update-password`, { data });
  },
  resendVerification(email) {
    return Api.post(`/users/${email}/resend-verification`);
  },
  updateCurrentUser(data) {
    return Api.put(`/users/update-current`, { data });
  },
  update(id, data) {
    return Api.put(`/users/${id}/update`, { data });
  },
  updateEmail(id, data) {
    return Api.put(`/users/${id}/update-email`, { data });
  },
  getAccountInfo(id, params) {
    return Api.get(`/users/${id}/account-info`, { params });
  },
  getPublicAccountInfo(id, params) {
    console.log(params);
    return Api.get(`/users/${id}/public-account-info`, { params });
  },
  setCompetitor(data) {
    return Api.put(`/users/create-competitor`, { data });
  },
  unsetField(data) {
    return Api.put('/users/unset-current', { data });
  },
  getByName(name) {
    return Api.get(`/users/get-name/${name}`);
  },
  getByEmail(email) {
    return Api.get(`/users/get-email/${email}`);
  },
  getAll(params) {
    return Api.get('/users/all', { params });
  },
  getKPIs() {
    return Api.get('/users/kpis');
  },
  getProfileBanner(id) {
    return Api.get(`/users/${id}/banner`);
  },
  getProfilePicture(id) {
    return Api.get(`/users/${id}/profile-picture`);
  }
};

export default UserAPI;
